{
  "toast": {
    "automationCreated": "Automation created",
    "actionAdded": "Action added",
    "boardCreated": "Board created",
    "dependencyAdded": "Dependency added",
    "issueCreated": "Issue created",
    "projectArchived": "Project archived",
    "projectCloned": "Project cloned",
    "projectCreated": "Project created",
    "ifRegisteredALoginLinkWasSentTo": "If registered, a login link was sent to your email",
    "signedIn": "Signed in",
    "portfolioCreated": "Portfolio created",
    "resourceAllocated": "Resource allocated",
    "documentUploaded": "Document uploaded",
    "projectCreatedFromTemplate": "Project created from template",
    "clientPortalUserCreated": "Client portal user created",
    "sprintStarted": "Sprint started",
    "sprintCompleted": "Sprint completed",
    "taskAddedToSprint": "Task added to sprint",
    "taskUpdated": "Task updated",
    "taskCreated": "Task created",
    "taskDeleted": "Task deleted",
    "timeLogged": "Time logged",
    "timesheetSubmitted": "Timesheet submitted",
    "reportExported": "{{reportType}} exported",
    "financeInvoiceCreated": "Finance invoice {{invoiceNumber}} created ({{lineCount}} lines)",
    "tasksSynced": "Synced {{count}} tasks to board"
  },
  "errors": {
    "failedToLoadAutomations": "Failed to load automations",
    "failedToLoadActions": "Failed to load actions",
    "createFailed": "Create failed",
    "addActionFailed": "Add action failed",
    "failedToLoadBoards": "Failed to load boards",
    "failedToLoadBoard": "Failed to load board",
    "createBoardFailed": "Create board failed",
    "syncFailed": "Sync failed",
    "moveFailed": "Move failed",
    "failedToLoadCalendar": "Failed to load calendar",
    "enterBothTaskIds": "Enter both task IDs",
    "failedToLoadGantt": "Failed to load Gantt",
    "addDependencyFailed": "Add dependency failed",
    "archiveFailed": "Archive failed",
    "cloneFailed": "Clone failed",
    "requestFailed": "Request failed",
    "verificationFailed": "Verification failed",
    "budgetLoadFailed": "Budget load failed",
    "reportsUnavailable": "Reports unavailable",
    "exportFailed": "Export failed",
    "failedToLoadResources": "Failed to load resources",
    "allocateFailed": "Allocate failed",
    "failedToLoadTemplates": "Failed to load templates",
    "uploadFailed": "Upload failed",
    "instantiateFailed": "Instantiate failed",
    "portalInviteFailed": "Portal invite failed",
    "backlogLoadFailed": "Backlog load failed",
    "startSprintFailed": "Start sprint failed",
    "completeSprintFailed": "Complete sprint failed",
    "assignFailed": "Assign failed",
    "selectAProject": "Select a project",
    "deleteFailed": "Delete failed",
    "enterBillingDateRange": "Enter billing date range",
    "logTimeFailed": "Log time failed",
    "billTimeFailedEnsureFinanceModuleAndBillable": "Bill time failed — ensure Finance module and billable hours exist",
    "submitFailed": "Submit failed",
    "analyticsUnavailable": "Analytics unavailable",
    "failedToLoadIssues": "Failed to load issues",
    "failedToLoadProjects": "Failed to load projects",
    "failedToLoadPortfolios": "Failed to load portfolios",
    "failedToLoadSprints": "Failed to load sprints",
    "failedToLoadTasks": "Failed to load tasks",
    "failedToLoadTimesheets": "Failed to load timesheets"
  },
  "pages": {
    "automation": "Automation",
    "createAutomation": "Create automation",
    "addWorkflowAction": "Add workflow action",
    "workflowTriggersAndActionsForTasks": "Workflow triggers and actions for tasks and sprints",
    "boards": "Boards",
    "createBoard": "Create board",
    "kanbanBoardsWithDragAndDrop": "Kanban boards with drag-and-drop, WIP limits, and workflow columns",
    "calendar": "Calendar",
    "milestonesAndTaskDueDates": "Milestones and task due dates",
    "projectsDashboard": "Projects Dashboard",
    "deliveryDetails": "Delivery details",
    "tasks": "Tasks",
    "issues": "Issues",
    "activeSprints": "Active Sprints",
    "deliveryHealthAcrossProjectsTasksIssues": "Delivery health across projects, tasks, issues, and sprints in your scope",
    "gantt": "Gantt",
    "timelineViewWithDependenciesAndCritical": "Timeline view with dependencies and critical path",
    "createIssue": "Create issue",
    "bugsAndDeskTicketEscalationsAuto": "Bugs and Desk ticket escalations (auto-linked from Desk)",
    "projects": "Projects",
    "createProject": "Create project",
    "portfolioOfClientAndInternalDelivery": "Portfolio of client and internal delivery projects",
    "projectClientPortal": "Project client portal",
    "verifyLogin": "Verify login",
    "viewYourProjectStatusTasksDocuments": "View your project status, tasks, documents, and invoices",
    "completeClientPortalSignIn": "Complete client portal sign-in",
    "pmoPortfolio": "PMO & Portfolio",
    "createPortfolio": "Create portfolio",
    "executiveDashboardPortfoliosAndProjectBudget": "Executive dashboard, portfolios, and project budget health",
    "projectReports": "Project Reports",
    "deliveryAnalyticsAndExportableReports": "Delivery analytics and exportable reports",
    "resourcePlanning": "Resource planning",
    "teamAllocationAndCapacityByProject": "Team allocation and capacity by project",
    "projectSetup": "Project Setup",
    "templatesClientPortalAndConfiguration": "Templates, client portal, and configuration",
    "pdfWordExcelOrImages": "PDF, Word, Excel, or images",
    "sprints": "Sprints",
    "startSprint": "Start sprint",
    "backlogSprintPlanningExecutionAndVelocity": "Backlog, sprint planning, execution, and velocity",
    "edit": "Edit",
    "delete": "Delete",
    "hierarchicalTasksWithCreateEditAnd": "Hierarchical tasks with create, edit, and delete",
    "timesheets": "Timesheets",
    "logTime": "Log time",
    "submitTimesheet": "Submit timesheet",
    "logTimeSubmitWeeklyTimesheetsAnd": "Log time, submit weekly timesheets, and approve hours",
    "workload": "Workload",
    "activeProjects": "Active projects",
    "taskCompletion": "Task completion",
    "loggedHoursMonth": "Logged hours (month)",
    "sprintVelocity": "Sprint velocity",
    "resourceUtilizationAndCapacityPlanning": "Resource utilization and capacity planning"
  },
  "labels": {
    "ruleName": "Rule name",
    "triggerEvent": "Trigger event",
    "actionType": "Action type",
    "boardCode": "Board code",
    "boardName": "Board name",
    "selectProject": "Select project",
    "taskId": "Task ID",
    "dependsOnTaskId": "Depends on task ID",
    "title": "Title",
    "description": "Description",
    "projectCode": "Project code",
    "projectName": "Project name",
    "budget": "Budget",
    "organizationId": "Organization ID",
    "email": "Email",
    "token": "Token",
    "code": "Code",
    "name": "Name",
    "allocation": "Allocation %",
    "clientEmail": "Client email",
    "uploadDocument": "Upload document",
    "sprintCode": "Sprint code",
    "sprintName": "Sprint name",
    "goal": "Goal",
    "backlogProject": "Backlog project",
    "allProjects": "All projects",
    "project": "Project",
    "date": "Date",
    "hours": "Hours"
  },
  "formActions": {
    "submitWeek": "Submit week"
  },
  "listActions": {
    "newProject": "New project",
    "newBoard": "New board",
    "syncTasks": "Sync tasks",
    "newPortfolio": "New portfolio",
    "newTask": "New task",
    "newIssue": "New issue",
    "newRule": "New rule",
    "logTime": "Log time",
    "startSprint": "Start sprint",
    "start": "Start",
    "useTemplate": "Use",
    "grantPortalAccess": "Grant portal access",
    "sendMagicLink": "Send magic link"
  }
}
